import type { TASCustomerEmailVerificationStatus } from '~/models/tas/TASCustomerDataResponse.model';
import FetchFactory from '../factory';
const CONTROLLER_PATH = '/api-electra/contactverification';

class BDLVerificationModule extends FetchFactory<TASCustomerEmailVerificationStatus> {
  async getEmailIsVerified(
    orderId: number,
  ): Promise<TASCustomerEmailVerificationStatus | undefined> {
    try {
      const result = await this.get(
        `${CONTROLLER_PATH}/EmailIsVerified?orderId=${orderId}`,
      );

      return result;
    } catch (e) {
      return undefined;
    }
  }
}

export default BDLVerificationModule;
